import React from 'react';
import { Check } from 'lucide-react';
import { COUNTRIES } from '../../utils/countryUtils';
import Bandera from '../ui/Bandera';

/**
 * Primera visita: qué catálogo se va a mostrar, y la opción de cambiarlo.
 *
 * Antes esto se decidía en silencio. La detección mira la zona horaria y sólo
 * puede devolver Argentina o España —son los dos catálogos que existen—, así
 * que quien entraba desde Italia o desde México aterrizaba en uno de los dos
 * sin saber por qué ni sospechar que había otro.
 *
 * El objetivo no es preguntar: es **explicar y dejar corregir**. Por eso el país
 * detectado viene preseleccionado y a un clic de distancia, y el otro está al
 * lado en vez de escondido en un desplegable. Quien esté donde corresponde
 * cierra esto en un gesto; quien no, en dos.
 *
 * Se muestra **una sola vez**. En cuanto hay una elección guardada no vuelve a
 * aparecer: para cambiar de país está el selector del encabezado, que es donde
 * uno lo busca.
 */
export const SelectorPaisInicial = ({ deteccion, onElegir }) => {
  const sugerido = COUNTRIES[deteccion.pais];
  const otro = Object.values(COUNTRIES).find(
    c => c.code !== deteccion.pais && c.disponible
  );

  if (!sugerido) return null;

  // Qué se le cuenta al usuario sobre por qué está viendo esto.
  //
  // Tres mensajes y no uno genérico: decir «parece que estás en Europa» a quien
  // entra desde Madrid suena a que el sitio no sabe dónde está, y decir «estás
  // en España» a quien entra desde Roma sería falso.
  let explicacion;
  if (deteccion.exacta) {
    explicacion = <>Detectamos que estás en <strong>{deteccion.zona}</strong>.</>;
  } else if (deteccion.zona) {
    explicacion = (
      <>Parece que estás en <strong>{deteccion.zona}</strong>. Todavía no tenemos
      un catálogo propio para tu país, así que te mostramos el más cercano.</>
    );
  } else {
    explicacion = <>No pudimos deducir desde dónde entrás.</>;
  }

  return (
    <div id="selector-pais-inicial" className="pais-inicial">
      <div className="pais-inicial__caja" role="dialog" aria-modal="true"
           aria-labelledby="selector-pais-inicial-titulo">
        <Bandera code={sugerido.code} size={56} className="pais-inicial__bandera" />

        <h2 id="selector-pais-inicial-titulo" className="pais-inicial__titulo">
          Ofertas de {sugerido.name}
        </h2>

        <p className="pais-inicial__texto">
          {explicacion}{' '}
          Vas a ver precios en {sugerido.currency} y tiendas que envían allá.
        </p>

        <button
          id="selector-pais-inicial-confirmar"
          className="pais-inicial__principal"
          onClick={() => onElegir(sugerido.code)}
          autoFocus
        >
          <Check size={16} />
          Continuar con {sugerido.name}
        </button>

        {otro && (
          <button
            id="selector-pais-inicial-cambiar"
            className="pais-inicial__secundario"
            onClick={() => onElegir(otro.code)}
          >
            <Bandera code={otro.code} size={18} />
            Prefiero ver las de {otro.name}
          </button>
        )}

        <p className="pais-inicial__pie">
          Después podés cambiarlo cuando quieras desde el selector de arriba.
        </p>
      </div>
    </div>
  );
};

export default SelectorPaisInicial;
